var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.73974 5.11183H0.938477C0.938477 15.3343 5.02409 20.9009 13.2042 20.9009V15.8367C15.9778 16.153 17.3951 17.9025 18.2349 20.9009L23.0609 20.9009C22.2953 17.6567 21.1647 14.65 18.2349 12.981C20.8496 11.1574 21.6766 8.20713 22.2322 5.09918H17.7377C16.9641 8.23675 15.6021 10.1009 13.4252 10.3666V5.11183H9.01453V14.3493C6.66573 14.1797 5.50395 9.82852 5.73974 5.11183Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.e6a7aa337511b8fcb827aed7dfa39946.svg";
export { ForwardRef as ReactComponent };